<app-dynamic-form
(submittedFormData)="receivedDynamicDataFn($event)"
(sendBlur)="blurEvent($event)"
[p]="patchValues"
[f]="formConfig"
[class]="class">
</app-dynamic-form>
